import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { JobDocHeaderLinkContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';


@Injectable({
  providedIn: 'root'
})
export class JobDocHdrLinkService extends BaseApiTemplateService<JobDocHeaderLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-dochdr-links';
    this.httpClient = http;
  }
}
